import Api from "@/helpers/api.js";
import DateUtils from "@/helpers/DateUtils.js";

import store from "@/store/index.js";
import Form from "@/serviforms/designer/provider/FormJsonData.js";
import {
  createForm,
  createPage,
  createDependence,
  createContador,
  inactiveAllForms
} from "@/serviforms/designer/indexDB/logic.js";

import {
  relatedParentsSimple,
  createRelatedSimple,
  relatedParentsListener,
  relatednessChildren,
  relatedParentsCompund,
  createRelatedListener,
  createRelatedCompound,
} from "@/serviforms/designer/library/dependencies";
const fixRelated = async (questions) => {
  return questions.map(question =>{
    if(question.hasOwnProperty('related') && question.related.hasOwnProperty('relatedness') && question.related.relatedness !== 'compound') {
      question.related.question = questions.findIndex(_question => _question.name === question?.related.name)
    }
    return question;
  })
}

const getForm = async (key, _version) => {
  try {
    const result = await Api.get(`/forms/${key}/${_version}`);
    const { formID, activity, groupID, version, formType, companyID } = result.data;
    const { questions, pages } = result.data.form;

    const fixRelatedQuestions = await fixRelated(questions)
    result.data.form.questions = fixRelatedQuestions;

    //CREATE RELATED SIMPLE
    const simple = relatedParentsSimple(result.data);
    const realtedSimple = createRelatedSimple(simple, result.data);

    //CREATE RELATED COMPOUND
    const compound = relatedParentsCompund(result.data);
    const relatedCompound = createRelatedCompound(compound);

    //CREATE RELATED LISTENER
    const listener = relatedParentsListener(result.data);
    const relatedListener = createRelatedListener(listener);

    //OBTENEMOS LOS CHILDREN
    const relatedness = relatednessChildren(result.data);

    const databases = result.data.databases;
    const form = new Form(questions, databases, pages);
    const _pages = form.getPages();
    const _columns = form.getColumnsSelect();
    const _count = _contador(questions);
    const id_page = await _createPage(_pages, formID);

    let isSubForm = "0";
    if (formType === "subforms") isSubForm = "1";
    if (formType === "bots") isSubForm = "2";

    await _createForm(
      activity,
      groupID,
      formID,
      version,
      isSubForm,
      realtedSimple,
      relatedness,
      relatedCompound,
      relatedListener,
      _columns,
      _count,
      id_page
    );

    store.commit("resource/CHANGE_DATA_SIDEBAR", {
      nameForm: activity,
      grupo: groupID,
      version,
      isSubForm,
      formID,
      companyID,
      disabledGroup: true
    });
  } catch (error) {
    console.log(error);
  }
};


const _contador = questions => {
  let arrayCount = [];
  for (var i in questions) {
    const question = questions[i];
    arrayCount.push(parseInt(question.name.split("_")[1]));
  }
  return Math.max(...arrayCount) + 1;
};

const _createPage = async (_pages, key) => {
  let first_id_page = "";
  const timeStamp = parseInt(DateUtils.timeStamp());
  let count = 1;

  for (var i in _pages) {
    const page = {
      id_form: key,
      questions: _pages[i],
      date_create: String(timeStamp + count)
    };
    const id_page = await createPage(page);
    if (count === 1) first_id_page = id_page;
    count++;
  }
  return first_id_page;
};

const _createForm = async (
  activity,
  groupID,
  key,
  version,
  isSubForm,
  _related,
  _dependencies,
  _compound,
  _listener,
  _columns,
  _count,
  id_page
) => {
  const { companyID, uuid } = store.state.user;
  await inactiveAllForms("formulario");
  const data = {
    method: "update",
    companyId: companyID,
    name: activity,
    groupId: groupID,
    uuid: uuid,
    version,
    formType: isSubForm,
    active: true
  };

  await createForm(data, key);

  const dependencias = {
    id_form: key,
    simple: _related !== undefined ? _related.objetRelated || _related : {},
    dependencias: _dependencies !== undefined ? _dependencies : [],
    listener: _listener !== undefined ? _listener : {},
    compound: _compound !== undefined ? _compound.objetCompound || _compound : {},
    columns: _columns !== undefined ? _columns : {}
  };

  const id_dependencia = await createDependence(dependencias);

  const contador = {
    id_form: key,
    contador: _count
  };

  const id_contador = await createContador(contador);

  store.commit("resource/UPDATE_STATE", { key: "idForm", value: key });
  store.commit("resource/UPDATE_STATE", { key: "idPage", value: id_page });
  store.commit("resource/UPDATE_STATE", { key: "idCounter", value: id_contador });
  store.commit("resource/UPDATE_STATE", { key: "idDependency", value: id_dependencia });
};

export const recreateIndexDB = {
  getForm
};
